{
  "columns": {
    "lca": {
      "completionIndex": "Précision",
      "dateCreated": "Mise à jour",
      "ecs": "Coût environnemental",
      "name": "Nom",
      "pef": "Score PEF (µPt PEF)",
      "reference": "Référence",
      "status": "Statut",
      "webUrl": "Détails"
    },
    "rdue": {
      "brandReference": "Référence de la marque",
      "compliant": "Conforme",
      "component": {
        "material": {
          "country": "Pays",
          "name": "Matériau",
          "scientificName": "Nom scientifique"
        }
      },
      "component_certificates": "Certificats du composant {{index}}",
      "component_details": "Détails du composant {{index}}",
      "composition": "Composition",
      "compositionCount_one": "{{count}} matériau",
      "compositionCount_many": "{{count}} matériaux",
      "compositionCount_other": "{{count}} matériaux",
      "documents": "Documents",
      "dueDiligence": "Déclaration de diligence raisonnable",
      "hsCode": "Code du Système Harmonisé",
      "name": "Nom",
      "purchaseOrder": "Bon de commande (BC)",
      "quantity": "Quantité par BC",
      "relevantCommodity": "Produit Commercialement Pertinent"
    }
  },
  "lists": {
    "labels": {
      "dueDiligence": "Générer une déclaration de diligence",
      "dueDiligence_one": "Générer une déclaration de diligence raisonnable pour {{count}} produit",
      "dueDiligence_many": "Générer une déclaration de diligence raisonnable pour {{count}} produits",
      "dueDiligence_other": "Générer une déclaration de diligence raisonnable pour {{count}} produits",
      "selectCompliant": "Sélectionner Conforme"
    },
    "placeholders": {
      "agec": "Conformité",
      "no": "Non",
      "rdueStatus": "Statut",
      "search": "Rechercher",
      "yes": "Oui"
    },
    "tabs": {
      "agec": "AGEC",
      "lca": "Affichage environnemental",
      "rdue": "EUDR"
    },
    "title": "Réglementations"
  },
  "notSubscribed": {
    "message": "Vous n'êtes pas abonné à cette fonctionnalité. Veuillez contacter votre gestionnaire de compte.",
    "title": "Pas d'abonnement"
  },
  "runLcaOnProducts_one": "Lancer une ACV sur {{count}} produit",
  "runLcaOnProducts_many": "Lancer une ACV sur {{count}} produits",
  "runLcaOnProducts_other": "Lancer une ACV sur {{count}} produits",
  "values": {
    "lca": {
      "error": "Produit inéligible à l'ACV",
      "errors": {
        "default": "Une erreur inattendue s’est produite. Merci d’essayer à nouveau ou de contacter l’équipe support.",
        "missingData": "Informations manquantes: {{args}}",
        "unaccessible": "Le service partenaire est en maintenance. Merci d’essayer à nouveau plus tard.",
        "unsupportedData": "Information non prise en charge par Ecobalyse: {{args}}"
      },
      "pending": "Pas d'ACV disponible",
      "success": "ACV effectuée avec succès"
    },
    "status": {
      "error_one": "Echec de la mise à jour (il y a {{count}} jour)",
      "error_many": "Echec de la mise à jour (il y a {{count}} jours)",
      "error_other": "Echec de la mise à jour (il y a {{count}} jours)",
      "success_one": "Mis à jour (il y a {{count}} jour)",
      "success_many": "Mis à jour (il y a {{count}} jours)",
      "success_other": "Mis à jour (il y a {{count}} jours)"
    }
  }
}
